var _slicedToArray = require("/var/lib/jenkins/workspace/fcom.openapi/FCOM_UAT/fcom.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/var/lib/jenkins/workspace/fcom.openapi/FCOM_UAT/fcom.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/var/lib/jenkins/workspace/fcom.openapi/FCOM_UAT/fcom.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

/* eslint-disable */
function getWpmjs() {
  var usemf = require('usemf');

  var resolveRequest = require('semverhook/src/utils/resolveRequest');

  var obj = {
    idUrlMap: {},
    idDefineMap: {// id: {
      //   // "promise"返回的是mf的规范{get(){},init(){}}
      //   remoteType: "mf" | "promise",
      //   name,
      // }
    },
    idModuleMap: {},
    idModulePromiseMap: {},
    get: function get(id) {
      return this.idModuleMap[id];
    },
    wait: function wait(pkgs) {
      var _this = this;

      if (!(pkgs instanceof Array)) {
        throw new Error("wait(pkgs)入参需要是数组");
      }

      if (pkgs.length === 0) {
        return Promise.resolve();
      }

      return Promise.all(pkgs.map(function (pkg) {
        return _this.import(pkg);
      }));
    },
    getMFContainer: function getMFContainer(id, customGetContainer) {
      var _this2 = this;

      var request = resolveRequest(id);
      var remoteType = this.idDefineMap[request.name].remoteType; // mf模块

      var config = this.idDefineMap[request.name];
      return usemf.getContainer({
        url: this.idUrlMap[request.name],
        name: config.name,
        customGetContainer: remoteType === "promise" ? function () {
          return new Function("return ".concat(_this2.idUrlMap[request.name]))();
        } : customGetContainer
      });
    },

    /**
     * dep发起的请求, 不会进此api
     * id: @scope....
     * id: https?://xxx.com/xxxxx
     * id: mfshare:scope:version:react
     * @param {*} id 
     * @returns 
     */
    import: function _import(id) {
      var _this3 = this;

      if (this.idModulePromiseMap[id]) return this.idModulePromiseMap[id];
      var importPromise = Promise.resolve(_asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var request, remoteType, config;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!id.startsWith("mfshare:")) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", _this3._importShare(id));

              case 2:
                request = resolveRequest(id);
                remoteType = _this3.idDefineMap[request.name].remoteType; // mf模块

                config = _this3.idDefineMap[request.name];
                return _context.abrupt("return", _this3._resolveMfEntry(usemf.import({
                  url: _this3.idUrlMap[request.name],
                  name: config.name,
                  customGetContainer: remoteType === "promise" ? function () {
                    return new Function("return ".concat(_this3.idUrlMap[request.name]))();
                  } : undefined
                }), request));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))());
      return this.idModulePromiseMap[id] = importPromise.then(function (res) {
        _this3.idModuleMap[id] = res;
        return res;
      });
    },
    _importShare: function () {
      var _importShare2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(id) {
        var _ref2, _ref3, scope, pkg, version, fn;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                id = id.replace("mfshare:", "");
                _ref2 = id.indexOf(":") > -1 ? id.split(":") : id.split("/"), _ref3 = _slicedToArray(_ref2, 3), scope = _ref3[0], pkg = _ref3[1], version = _ref3[2];
                _context2.next = 4;
                return usemf.getShareScopes()[scope][pkg][version].get();

              case 4:
                fn = _context2.sent;
                return _context2.abrupt("return", fn());

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function _importShare(_x) {
        return _importShare2.apply(this, arguments);
      }

      return _importShare;
    }(),

    /**
     * 解析mf入口
     * @param {*} modulePromise 
     * @param {*} id 
     * @returns 
     */
    _resolveMfEntry: function () {
      var _resolveMfEntry2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(loadModule, request) {
        var entry;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return loadModule.continerInitPromise;

              case 2:
                entry = request.entry;

                if (!entry) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", loadModule("./" + entry));

              case 5:
                return _context3.abrupt("return", loadModule());

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function _resolveMfEntry(_x2, _x3) {
        return _resolveMfEntry2.apply(this, arguments);
      }

      return _resolveMfEntry;
    }(),
    setConfig: setConfig
  };

  function setConfig(customConfig) {
    var _this4 = this;

    customConfig = customConfig || {};
    var _customConfig = customConfig,
        _customConfig$idUrlMa = _customConfig.idUrlMap,
        idUrlMap = _customConfig$idUrlMa === void 0 ? {} : _customConfig$idUrlMa,
        _customConfig$idDefin = _customConfig.idDefineMap,
        idDefineMap = _customConfig$idDefin === void 0 ? {} : _customConfig$idDefin;
    Object.keys(idUrlMap).forEach(function (key) {
      if (key in _this4.idUrlMap) return;
      _this4.idUrlMap[key] = idUrlMap[key];
    });
    Object.keys(idDefineMap).forEach(function (key) {
      if (key in _this4.idDefineMap) return;
      _this4.idDefineMap[key] = idDefineMap[key];
    });
  }

  return obj;
}

var wpmjs = getWpmjs();

var localShared = require("/var/lib/jenkins/workspace/fcom.openapi/FCOM_UAT/fcom.fs2pro/source/$_mfplugin_virtualLocalShared/index.js");

var _require = require("/var/lib/jenkins/workspace/fcom.openapi/FCOM_UAT/fcom.fs2pro/source/$_mfplugin_virtualSetShared/index.js"),
    getUsedShare = _require.getUsedShare;

function pkgFilter(pkg) {
  var _ref4 = pkg.split("mfshare:") || [],
      _ref5 = _slicedToArray(_ref4, 2),
      prefix = _ref5[0],
      shareName = _ref5[1];

  if (shareName) {
    var _getUsedShare = getUsedShare(shareName),
        version = _getUsedShare.version,
        shareScope = _getUsedShare.shareScope;

    return "mfshare:".concat(shareScope, ":").concat(shareName, ":").concat(version);
  }

  return pkg;
}

if (!window["__mfplugin__apg_app"]) {
  window["__mfplugin__apg_app"] = {
    wpmjs: wpmjs,
    initSharedPromise: null,
    initedShared: false,
    chunkMap: {},
    get: function get() {
      var pkg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      if (!this.initedShared) {
        throw new Error("'" + pkg.replace("mfshare:", "") + "'" + " cannot be used in entry chunk, please complete the bootstrap（see： https://webpack.js.org/concepts/module-federation/#troubleshooting）");
      }

      return wpmjs.get(pkgFilter(pkg));
    },
    import: function _import() {
      var pkg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return wpmjs.import(pkgFilter(pkg));
    },
    wait: function () {
      var _wait = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(pkgs) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.initSharedPromise;

              case 2:
                pkgs = pkgs || [];
                return _context4.abrupt("return", Promise.all([wpmjs.wait(pkgs.map(pkgFilter))]));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function wait(_x4) {
        return _wait.apply(this, arguments);
      }

      return wait;
    }()
  };
}

var _require2 = require("/var/lib/jenkins/workspace/fcom.openapi/FCOM_UAT/fcom.fs2pro/source/$_mfplugin_virtualSetShared/index.js"),
    initShared = _require2.initShared;

var initConfig = {
  "idUrlMap": {
    "copytrade_app": "new Promise(async (resolve, reject) => {\n    try {\n      const remoteUrlWithVersion = window._env_.copytrade_app_url + '/remoteEntry.js'\n      const res = await fetch(remoteUrlWithVersion, { method: 'GET' });\n      if (res.ok) {\n        const script = document.createElement('script')\n        script.src = remoteUrlWithVersion\n        script.onload = () => {\n          const proxy = {\n            get: (request) => window.copytrade_app.get(request),\n            init: (...arg) => {\n              try {\n                return window.copytrade_app.init(...arg)\n              } catch (e) {\n                console.log('remote container already initialized')\n              }\n            }\n          }\n          resolve(proxy)\n        }\n        script.onerror = () => {\n          resolve({\n            get: () => () => Promise.resolve(() => ({})),\n            init: () => {}\n          })\n        }\n        document.head.appendChild(script);\n      } else {\n        resolve({\n          get: () => () => Promise.resolve(() => ({})),\n          init: () => {}\n        })\n      }\n    } catch (err) {\n      resolve({\n        get: () => () => Promise.resolve(() => ({})),\n        init: () => {},\n      });\n    }\n  })"
  },
  "idDefineMap": {
    "copytrade_app": {
      "remoteType": "promise",
      "name": "copytrade_app"
    }
  }
};
wpmjs.setConfig(initConfig);
window["__mfplugin__initSharedPromise__apg_app"] = Promise.resolve(initShared()).then(function () {
  window["__mfplugin__apg_app"].initedShared = true;
});